import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-archicad',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Archicad icon</title><path d="M22.5896 16.3222c-.779 0-1.4104-.6315-1.4104-1.4105 0-.779.6314-1.4104 1.4104-1.4104S24 14.1328 24 14.9117c0 .779-.6315 1.4105-1.4104 1.4105zM.1507 19.8272c-.35.6959-.0696 1.5438.6263 1.8938.6959.35 1.5438.0695 1.8938-.6263 0 0 7.8494-16.0114 14.2545-16.1487 4.2299-.0907 4.2313 5.642 4.2313 5.642 0 .779.6314 1.4104 1.4104 1.4104s1.4104-.6314 1.4104-1.4104c0 0 .0566-8.3813-7.0196-8.4569C8.7634 1.8711.1507 19.8272.1507 19.8272z"/></svg>`,
    styles: []
})
export class SimpleIconsArchicadComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#2D50A5';
    @Input() className: string = 'simple-icons-archicad'
    constructor() {}
    ngOnInit(): void {}
}
